import { getFunctionName } from '../get-function-name'
import isEmpty from 'lodash/isEmpty'

export const requiredCheck = (obj: any, paramName?: string) => {
  if (!obj) {
    const funcName = getFunctionName()
    paramName = paramName || '<not specified>'
    throw new Error(`${funcName}.${paramName} is required`)
  }
}

export const requiredEvenEmptyCheck = (obj: any, paramName?: string) => {
  if (isEmpty(obj)) {
    const funcName = getFunctionName()
    paramName = paramName || '<not specified>'
    throw new Error(`${funcName}.${paramName} is required`)
  }
}
